module.exports = __webpack_public_path__ + "img/agentAndVideo.c981e03c.svg";